import { unwrapResult } from '@reduxjs/toolkit';
import { Button, Form, Input, message } from 'antd';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';
import { getSetting, updateSetting } from 'store/global/action';
import { useAppDispatch } from 'store/hooks';
import './Setting.scss';

const Setting = () => {
  const [form] = Form.useForm();

  const dispatch = useAppDispatch();

  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchData = async () => {
    try {
      const res: any = await unwrapResult(await dispatch(getSetting()));
      console.log(res);
      setData(res);
    } catch (e) {
      console.log(e);
    }
  };

  const isMultipleRows = (text: string) => {
    return text.includes('\n') || text.includes('\r');
  };

  const onSubmit = async (values: any) => {
    const valid = await form.validateFields();
    if (!valid) return;
    try {
      setLoading(true);
      await unwrapResult(await dispatch(updateSetting(values)));
      message.success('Updated successfully');
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      {data && (
        <div className="content setting-detail-content">
          <div className="setting-detail-content__form">
            <Form
              name="basic"
              onFinish={onSubmit}
              autoComplete="off"
              layout="vertical"
              className="default"
              form={form}
              initialValues={data}
            >
              <Row>
                <Col md="6">
                  <Form.Item
                    label="Latest iOS version"
                    name="latestIosVersion"
                    rules={[
                      {
                        required: true,
                        message: 'Latest iOS version is required',
                      },
                      {
                        min: 1,
                        message:
                          'Latest iOS version must be at least 1 characters',
                      },
                      {
                        max: 10,
                        message:
                          'Latest iOS version must be no more than 10 characters',
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>

                <Col md="6">
                  <Form.Item
                    label="Latest Android version"
                    name="latestAndroidVersion"
                    rules={[
                      {
                        required: true,
                        message: 'Latest Android version is required',
                      },
                      {
                        min: 1,
                        message:
                          'Latest Android version must be at least 1 characters',
                      },
                      {
                        max: 10,
                        message:
                          'Latest Android version must be no more than 10 characters',
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>

              <Form.Item>
                <Button
                  className="btn btn-primary"
                  htmlType="submit"
                  loading={loading}
                >
                  Update
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      )}
    </>
  );
};

export default Setting;
